export const boardWidthOriginal: number = 5250
export const boardHeightOriginal: number = 3500
